import { useTranslation } from 'react-i18next';
import {
	GetPreworkGroupResponse,
	PagingConfig,
	PreworkGroupFilter,
} from '../../../shared/PreWorkServiceTypes';
import { GroupsTableColumns } from '../../prework/ColumnsPrework';
import { Table } from 'antd';
import { FilterGroupsPrework } from './FilterGroups';
import { tablePaginationConfiguration } from '../../../shared/Utils';

export const GroupsTablePrework = ({
	data: { preworkGroup, pagination },
	onGroupsPageChange,
	groupPageConfig,
	groupsFilter,
	onGroupsFilterChange,
	selectedBatchId,
}: {
	data: GetPreworkGroupResponse;
	onGroupsPageChange: (page: number, pageSize: number) => void;
	groupPageConfig: PagingConfig;
	groupsFilter: PreworkGroupFilter | undefined;
	onGroupsFilterChange: (value: PreworkGroupFilter) => void;
	selectedBatchId: number | undefined;
}) => {
	const { t } = useTranslation();
	const tablePaginationConfig = tablePaginationConfiguration(
		groupPageConfig,
		pagination,
		onGroupsPageChange
	);

	const columns = GroupsTableColumns();

	if (preworkGroup && preworkGroup.length && preworkGroup.length === 0) {
		return <div>{t('noDataFound')}</div>;
	}

	return (
		<>
			<FilterGroupsPrework
				value={groupsFilter}
				onFilterChange={onGroupsFilterChange}
				selectedBatchId={selectedBatchId}
			/>
			<Table
				dataSource={preworkGroup}
				columns={columns}
				pagination={tablePaginationConfig}
			/>
		</>
	);
};
